import script from "./bindUser.vue?vue&type=script&setup=true&lang=js"
export * from "./bindUser.vue?vue&type=script&setup=true&lang=js"

import "./bindUser.vue?vue&type=style&index=0&id=03fc83ac&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03fc83ac"]])

export default __exports__